module.exports = __webpack_public_path__ + "public/images/icon-facebook.c92c8da5f54b5eef55c049ad4f116274.svg";